import OpenDataCarto from "./opendata-carto.js";

class EnedisCarto extends OpenDataCarto {

    constructor(types) {
        super(types);
        this.opacity = 1;
    }

    get baseUrl() {
        return "https://data.enedis.fr";
    }

    get geoField() {
        return "geo_point_2d";
    }
    
}

export default EnedisCarto;